import React from 'react'
import axios from 'axios'
import qs from 'qs'
import { 
    Flex, FlexItem, FormCell, CellHeader, Label, CellBody, Input, Form,
    Button, TextArea, CellsTitle, Dialog, Toast, Toptips
} from 'react-weui'
import { Page } from '../components'
import { isLZWKAPP, isWeiXin, isAndroid } from '../utils'
import { goBack } from '../utils/connectApp'
import FileDialog from 'file-dialog'
import '../css/page/ProfileEditPage.css'
import { WKOwnDialog } from '../components/wk'


class ProfileEditPage extends React.Component {
    constructor (props) {
        super(props)
        // 获取验证码的时间间隔s
        this.COUNT_DOWN = 60
        this.state = {
            avatar: '',
            file: '',
            name: '',
            intro: '',
            isSubmitting: false,
            alertDialog: {
                isShow: false,
                text: '',
            },
            // 保存失败信息弹框
            failedDialog: {
                isShow: false,
                text: '',
            },
            tip: {
                isShow: false,
                text: '',
            },
            tips: {
                isShowUnfollowDialog: false,
                text: ''
            }
            
        }
    }
    componentDidMount () {
        document.title = '编辑'
        this.fetchProfile()
        //风控
        this.page.showFengKongTip()
    }
    fetchProfile () {
        this.setState({ isSubmitting: true })
        axios.get('/api/account/personal')
            .then(res => {
                const accountRes = res.data.data.account
                this.setState({
                    avatar: accountRes.small_avatar_url,
                    name: accountRes.nickname,
                    intro: accountRes.introduction,
                    isSubmitting: false,
                    id: accountRes.id,
                    isVerify: accountRes.is_vip,
                })
            })   
    }
    postProfile () {
        this.setState({ isSubmitting: true })
        const formData = new FormData()
        formData.append('nickname', this.state.name)
        formData.append('introduction', this.state.intro)
        if(isWeiXin() && isAndroid()) {
            formData.append('from', 'weixin')
            // formData.append('is_test', 1)
            formData.append('content', this.state.file || '')
        } else {
            formData.append('headimgurl', this.state.file ? this.state.file : '')
        }
        axios.post('/api/account/edit', formData)
            .then(res => {
                this.setState({ isSubmitting: false })
                if (res.data.code === 0) {
                    this.setState({ alertDialog: { isShow: true, text: '修改成功'} })
                } else {
                    // alert(res.data.msg)
                    this.setState({ failedDialog: { isShow: true, text: `${res.data.msg}`} })
                }
            })
    }
    bindValue (e, field) {
        this.setState({ [field]: e.target.value })
    }
    handleChangeFile (e) {
        if(isWeiXin() && isAndroid()) {
            window.wx.chooseImage({
                count: 1, // 默认9
                sizeType: ['origin'], // 可以指定是原图还是压缩图，默认二者都有
                sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
                success: res => {
                    if(res.localIds.length > 0) {
                        const localId = res.localIds[0]
                        window.wx.uploadImage({
                           localId,
                           isShowProgressTips: 1,
                           success: uRes => {
                              this.setState({ avatar: localId, file: uRes.serverId })
                           },
                        })
                    }
                },
                fail: err => {
                    console.log(err)
                }
            })
        } else {
            FileDialog()
               .then(files => {
                   const file = files[0]
                   if (!file) return
                   const _this = this
                   const reader = new FileReader()
                   reader.readAsDataURL(file)
                   reader.onload = function(e) {
                       _this.setState({ avatar: this.result, file })
                   }
               })
        }
    }
    handleSubmit () {
        const { file, name, intro } = this.state

        const now = new Date().getTime()
        const start_time = new Date(2019,8,27).getTime()
        const end_time = new Date(2019,9,8).setHours(12, 0, 0, 0)
        if(now > start_time && now < end_time) {
            this.setState({ tip: { isShow: true, text: '亲爱的用户，因系统升级，暂时无法修改个人资料，如有疑问，请联系客服咨询' } })
            setTimeout(() => {
                this.setState({ tip: { isShow: false } })
            }, 2000)
            return   
        }

        if (name === '') {
            this.setState({ tip: { isShow: true, text: '请填写昵称' } })
            setTimeout(() => {
                this.setState({ tip: { isShow: false } })
            }, 2000)
            return
        }
        if(name.length > 30) {
            this.setState( { tips: {isShowUnfollowDialog: true, text: '昵称长度应为1-30个字符' } })
            return
        }
        this.postProfile()
    }
    onClickDialogOk () {
        this.setState({ alertDialog: { isShow: false } })
        if (!isLZWKAPP()) {
            location.assign('/account/')
        } else {
            goBack()
        }
    }
    
    onClickFailedDialog () {
        this.setState({failedDialog: {isShow: false}})
    }
    onClickUnfollowDialogCancle () {
        this.setState( { tips: { isShowUnfollowDialog: false, text: '' } })
    }
    onClickUnfollowDialogOk () {
        this.setState( { tips: { isShowUnfollowDialog: false, text: ''  } })
    }
    render() {
        return (
            <Page parent={this}>
                <div className="wk-inner-page profile-edit-page">
                    <div className="avatar-edit">
                        <div 
                            className="upload-input"
                            onClick={this.handleChangeFile.bind(this)} 
                        />
                        <Flex>
                            <FlexItem>
                                <label>头像</label>
                            </FlexItem>
                            <FlexItem className='weui-flex__item avatar-flex'>
                                <div className="portrait text-right">
                                    <img id="avatar" src={this.state.avatar} />
                                </div>
                            </FlexItem>
                        </Flex>
                    </div>
                    <div className='panel wk-position-rlt wk-border-line-after'>
                        <FormCell>
                            <CellHeader>
                                <Label>昵称</Label>
                            </CellHeader>
                            <CellBody>
                                <Input className="nickname" value={this.state.name} onChange={e => this.bindValue(e, 'name')} type="text" placeholder="请输入昵称" />
                            </CellBody>
                        </FormCell>
                    </div>
                    <CellsTitle>我的介绍（将显示在课程介绍的页面）</CellsTitle>
                    <div className='panel intro'>
                        <Form>
                            <FormCell>
                                <CellBody>
                                    <TextArea 
                                        value={this.state.intro} 
                                        onChange={e => this.bindValue(e, 'intro')} 
                                        placeholder="请输入我的介绍" 
                                        rows="5" 
                                        showCounter={false}
                                    >
                                    </TextArea>
                                </CellBody>
                            </FormCell>
                        </Form>
                    </div>
                    <div className="btn-wrap">
                        <Button type='primary' onClick={e => this.handleSubmit()}>保存</Button>
                    </div>
                    {/* 提示tip  */}
                    <Toptips type="warn" show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
                    {/* 成功dialog  */}
                    <Dialog type="ios" title='' buttons={[
                        { type: 'primary', label: '确定', onClick: () => this.onClickDialogOk() },
                    ]} show={this.state.alertDialog.isShow}>
                        {this.state.alertDialog.text}
                    </Dialog>
                    {/* 失败dialog  */}
                    <Dialog type="ios" title='错误信息' buttons={[
                        { type: 'primary', label: '确定', onClick: () => this.onClickFailedDialog() },
                    ]} show={this.state.failedDialog.isShow}>
                        {this.state.failedDialog.text}
                    </Dialog>
                    {/* loading toast  */}
                    <Toast icon="loading" show={this.state.isSubmitting}></Toast>
                    {/* 确认取消提示 */}
                    <WKOwnDialog show={this.state.tips.isShowUnfollowDialog} type="ios"
                        title='温馨提示'
                        buttons={[{
                            label: '取消',
                            type: 'default',
                            onClick: () => this.onClickUnfollowDialogCancle()
                        }, {
                            label: '确认',
                            onClick: () => this.onClickUnfollowDialogOk()
                        }]}
                    >
                        { this.state.tips.text }
                    </WKOwnDialog>
                </div>
            </Page>
        )
    }
}

export default ProfileEditPage


// WEBPACK FOOTER //
// ./src/pages/ProfileEditPage.js